import { render, staticRenderFns } from "./fryer-polaris-3-frying-page.vue?vue&type=template&id=fd6a5960&scoped=true"
import script from "./fryer-polaris-3-frying-page.vue?vue&type=script&lang=js"
export * from "./fryer-polaris-3-frying-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6a5960",
  null
  
)

export default component.exports